import baseService from './baseService'

export const dataServices = {
    getDataForCustomers,
    getDataForFilters,
    getSmeDataForFilters,
    getMikroDataForFilters,
    getDataForEditFilters,
    editUserInformation,
    editApplicationStatus,
    fetchExportHistory,
    scoreCustomer,
    getLearningResources
}

function getDataForCustomers (data) {
    return baseService.postRequest('/api/secure/result/customer', data)
}

function getDataForFilters() {
    return baseService.getRequest('/api/secure/result/dropDownData')
}

function getSmeDataForFilters() {
    return baseService.getRequest('/api/secure/result/smeDropDownData')
}

function getMikroDataForFilters() {
    return baseService.getRequest('/api/secure/result/mikroDropDownData')
}

function getDataForEditFilters() {
    return baseService.getRequest('/api/secure/result/dropDownDataForEditFilters')
}

function editUserInformation(data) {
    return baseService.postRequest('/api/secure/result/editUserInformation', data)
}

function scoreCustomer(data) {
    return baseService.postRequest('/api/secure/result/scoreCustomer', data)
}

function fetchExportHistory () {
    return baseService.getRequest('/api/secure/result/exportHistory')
}

function getLearningResources () {
    return baseService.getRequest('/api/secure/result/learningResources')
}
function editApplicationStatus(data) {
    return baseService.postRequest('/api/secure/result/editApplicationStatus', data)
}
